import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { routes } from '../routes/routes';
import { URL_SERVICIOS } from 'src/app/config/config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { catchError, map, of } from 'rxjs';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  user: any;
  token: any;

  constructor(
    private router: Router,
    public http: HttpClient,
  ) {
    this.getLocalStorage();
  }

  getLocalStorage() {
    if (this.hasValidSession()) {
      let USER = localStorage.getItem("user");
      this.user = JSON.parse(USER ? USER : '');
      this.token = localStorage.getItem("token");
    } else {
      this.clearSession();
    }
  }

  hasValidSession(): boolean {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    if (!token || !user) return false;
    try {
      const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
      const { exp } = JSON.parse(atob(payload));
      return !!JSON.parse(user) && typeof exp === 'number' &&
        Number.isFinite(exp) && Date.now() < exp * 1000;
    } catch {
      return false;
    }
  }

  clearSession(): void {
    ['token', 'user', 'authenticated', 'sipe_locked', 'sipe_locked_reason']
      .forEach(key => localStorage.removeItem(key));
    this.user = null;
    this.token = null;
  }

  login(email: any, password: any) {
    let URL = URL_SERVICIOS + "/auth/login";

    return this.http.post(URL, { email: email, password: password }).pipe(
      map((auth: any) => {
        const result = this.saveLocalStorage(auth);
        return result;
      }),
      catchError((error: any) => {
        console.log(error);

        // No oculto el error porque el componente login necesita leer
        // el message_text que manda Laravel.
        return throwError(() => error);
      })
    );
  }

  forgotPassword(email: string) {
    let URL = URL_SERVICIOS + "/forgot-password";

    return this.http.post(URL, {
      email: email
    });
  }

  resetPassword(data: any) {
    let URL = URL_SERVICIOS + "/reset-password";

    return this.http.post(URL, data);
  }

  //inactividad x 5 minutos
  verificarPassword(password: string) {
    const token = this.token || localStorage.getItem('token');

    let headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    });

    let URL = URL_SERVICIOS + '/verificar-password';

    return this.http.post(URL, {
      password: password
    }, {
      headers: headers
    });
  }

  saveLocalStorage(auth: any) {
    if (auth && auth.access_token) {
      localStorage.setItem("token", auth.access_token);
      localStorage.setItem("user", JSON.stringify(auth.user));
      localStorage.setItem('authenticated', 'true');
      localStorage.removeItem('sipe_locked');
      localStorage.removeItem('sipe_locked_reason');
      this.getLocalStorage();

      return this.hasValidSession();
    }

    return false;
  }

  logout() {
    this.clearSession();
    this.router.navigate([routes.login], { replaceUrl: true });
  }
}